import { getOpstartDate } from './voorraadbeheer';

/**
 * De Kolomnamen voor de plank.
 * De namen worden gebruikt in de code en voor het opslaan van de filters,
 * In geval van dynamische kolomnamen (zie voorraadbeheer) gebruik voorraadbeheer
 * als sleutel en maak een aparte weergave voor de display name.
 */
const _ddpColumns = [
  'Manco',
  'Reserve',
  'Verkeerd mat',
  'Defect inzetbaar',
  'Defect beperkt inzetbaar',
  'Defect niet inzetbaar',
  'Onderhoud & herstel',
];
export const ddpColumns = ['Voorraadbeheer', ..._ddpColumns];
export const columnVoorraadDisplayName = () => `Over / tekort opstart ${getOpstartDate()}`;

export const isDefectColumn = (col: string): boolean => col.startsWith('Defect') || col === 'Onderhoud & herstel';

/** Add text to a selected array or delete the item if it already exists.
 *
 * @param text to be added or deleted if it is already in selected.
 * @param selected the list where the text must be added to or deleted from.
 * @param keepLast should last element be kept
 * @returns adjusted selected.
 */
export const addOrDeleteArrayItem = (text: string, selected: string[], keepLast = true): string[] => {
  if (selected.includes(text)) {
    if (keepLast && selected.length !== 1) selected.splice(selected.indexOf(text), 1); // cant delete the last
    if (!keepLast) selected.splice(selected.indexOf(text), 1);
  } else {
    selected.push(text);
  }
  return selected;
};
